<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<div class="paddingbottom50">
			<van-field
			   v-model="listData.exp_social"
			   type="textarea"
			   clearable
			   rows="3"
			   autosize
			   label="个人经历"
			   placeholder="请输入个人经历"
			 />
			<van-field
			   v-model="listData.remark"
			   type="textarea"
			   clearable
			   rows="4"
			   autosize
			   label="个人备注"
			   placeholder="请输入个人备注"
			 />
		</div>
		<div class="fixBottom">
			<van-button  @click="save" type="info" size="large">保存</van-button>
		</div>
	</joy-page>
</template>

<script>
	export default{
		created() {
			this.loadData();
		},
		data(){
			return{
				joyPageStatus:'',
				listData:'',
			}
		},
		methods:{
			save(){
				const that=this;
				if(that.listData.exp_social=="" || that.listData.exp_social==null){
					that.$dialog.alert({
					  message: '个人经历不能为空'
					});
				}else if(that.listData.remark=="" || that.listData.remark==null){
					that.$dialog.alert({
					  message: '个人备注不能为空'
					});
				}else{
					let query={
						"remark":that.listData.remark,
						"exp_social":that.listData.exp_social,
					};
					try{
						that.$axios.post('user/update2',query).then(res => {
							if(res.data.code==200){
								that.$toast.success('保存成功');
								setTimeout(function() {
										that.$router.go(-1)
								}, 1000);
							}else{
								that.$toast.fail(res.data.msg)
							}
						})
					}catch(e){
						if (this.$mConfig.debug) {
							console.log(e);
						};
					}
				}
			},
			loadData(){
				try{
					this.joyPageStatus = 'loading';
					this.$axios.get('user/info').then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.listData=res.data.data;
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		
	}
	
</script>

<style scoped="scoped">
</style>
